import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import { durationInSeconds } from 'modules/core/lib/duration'
import { TIME_REGEX } from 'modules/core/lib/formatTime'
import users from 'modules/core/store/collections/users'

import ShiftConfiguration, {
  DAY_TYPE,
} from 'modules/shift_management/store/api/models/ShiftConfiguration'

class ShiftConfigForm extends Form {
  constructor(values: object) {
    super(values, {
      id: 'number',
      weekday: 'number',
      start_at: 'string',
      end_at: 'string',
      day_type: 'string',
    })
    makeObservable(this, {
      id: computed,
      weekday: computed,
      startAt: computed,
      endAt: computed,
      formattedStartAt: computed,
      formattedEndAt: computed,
      dayType: computed,
      isValid: computed,
      duration: computed,
      isOvernight: computed,
      isShift: computed,
      isRestDay: computed,
    })
  }

  get id(): number {
    return this.get('id').value
  }

  get weekday(): string {
    return this.get('weekday').value
  }

  get startAt(): string {
    return this.get('start_at').value
  }

  get endAt(): string {
    return this.get('end_at').value
  }

  get formattedStartAt() {
    return moment(this.startAt, 'HH:mm')
  }

  get formattedEndAt() {
    return moment(this.endAt, 'HH:mm')
  }

  get dayType(): string {
    return this.get('day_type').value
  }

  get isValid(): boolean {
    return (
      this.isRestDay ||
      this.isEmptyCell ||
      (!!this.get('start_at').value.match(TIME_REGEX) &&
        !!this.get('end_at').value.match(TIME_REGEX))
    )
  }

  get duration(): number {
    const startAtValue = this.get('start_at').value
    const endAtValue = this.get('end_at').value

    if (!startAtValue || !endAtValue) return 0

    return startAtValue === endAtValue
      ? 86400 // 24 hours in seconds
      : durationInSeconds(startAtValue, endAtValue, users.current.isTimeFormat24H)
  }

  get isOvernight(): boolean {
    const startTime = this.get('start_at').value
    const endTime = this.get('end_at').value

    return endTime && startTime && endTime <= startTime
  }

  get isShift(): boolean {
    return this.get('day_type').value === DAY_TYPE.shift
  }

  get isRestDay(): boolean {
    return this.get('day_type').value === DAY_TYPE.restDay
  }

  get isEmptyCell(): boolean {
    return this.get('day_type').value === DAY_TYPE.emptyCell
  }

  isMatchWith(shiftConfiguration: ShiftConfiguration): boolean {
    const { id, start_at, end_at, weekday } = shiftConfiguration.attributes
    return (
      this.id === id ||
      (+this.weekday === weekday && this.startAt === start_at && this.endAt === end_at)
    )
  }
}

export default ShiftConfigForm
